export const paymentTypes = {
  INCOME: 'income',
  OUTCOME: 'outcome',
}
